import Service from './service'
export var ApiMailMessageType;
(function (ApiMailMessageType) {
  ApiMailMessageType["MAIL_SENDER_REQUEST"] = "mail.sender.request"
  ApiMailMessageType["MAIL_SENDER_RESPONSE"] = "mail.sender.response"
})(ApiMailMessageType || (ApiMailMessageType = {}))
export var MailMessageType;
(function (MailMessageType) {
  MailMessageType["MAIL_SUCCESS"] = "MAIL_SUCCESS"
  MailMessageType["MAIL_ERROR"] = "MAIL_ERROR"
})(MailMessageType || (MailMessageType = {}))
/**
 * Сервис для работы с электронной почтой
 * @version 0.0.1
 * @since 1.9.1
 */
export default class MailService extends Service {
  constructor(messageChannel) {
    super(messageChannel)
    const messageHandler = (message) => {
      switch (message.type) {
        case ApiMailMessageType.MAIL_SENDER_RESPONSE:
          if (message.status === 'success') {
            this.broadcast(MailMessageType.MAIL_SUCCESS)
          }
          else if (message.status === 'error') {
            this.broadcast(MailMessageType.MAIL_ERROR, {
              code: message.code,
              text: message.text,
            })
          }
          break
      }
    }
    this.messageChannel.subscribe(ApiMailMessageType.MAIL_SENDER_RESPONSE, messageHandler)
  }
  /**
     * Сервис сообщил об успешной отправке
     *
     * @since 1.9.1
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof MailService
     *
     * @example <caption>Сервис сообщил об успешной отправке</caption>
     * robot.mailService.onSuccess(() => {
     *   ...
     * })
     */
  onSuccess(callback) {
    return this.subscribe(MailMessageType.MAIL_SUCCESS, callback)
  }
  /**
     * Сервис сообщил об ошибке отправки
     *
     * @since 1.9.1
     * @param {(code: string, text: string) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof MailService
     *
     * @example <caption>Сервис сообщил об ошибке отправки</caption>
     * robot.mailService.onError((code, text) => {
     *   ...
     * })
     */
  onError(callback) {
    return this.subscribe(MailMessageType.MAIL_ERROR, callback)
  }
  /**
     * Отправка письма
     *
     * @since 1.9.1
     * @param {string} email - получатель
     * @param {string} [subject=''] - тема письма
     * @param {string} [body=''] - тело письма
     * @param {string} attach - путь к приложенному файлу
     * @memberof MailService
     *
     * @example <caption>отправка письма</caption>
     * robot.mailService.sendMail(email, subject, body, attach)
     */
  sendMail(email, subject = '', body = '', attach) {
    if (email) {
      this.messageChannel.send({
        type: ApiMailMessageType.MAIL_SENDER_REQUEST,
        email,
        subject,
        body,
        filename: attach
      })
    }
  }
}
